import { render } from "./FooterRow.vue?vue&type=template&id=5424058a&lang=pug"
import script from "./FooterRow.vue?vue&type=script&lang=js"
export * from "./FooterRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/footer/FooterRow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5424058a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5424058a', __exports__)) {
    api.reload('5424058a', __exports__)
  }
  
  module.hot.accept("./FooterRow.vue?vue&type=template&id=5424058a&lang=pug", () => {
    api.rerender('5424058a', render)
  })

}


export default __exports__